<ion-content fullscreen>
  <section class="camera">
    <div
      class="camera__overlay"
      *ngIf="question.overlay !== PhotoOverlay.noOverlay"
      [ngClass]="{
      'camera__overlay-face_portrait': question.overlay === PhotoOverlay.face && question.orientation === PhotoOrientation.portrait,
      'camera__overlay-face_landscape': question.overlay === PhotoOverlay.face && question.orientation === PhotoOrientation.landscape,
      'camera__overlay-circle_portrait': question.overlay === PhotoOverlay.circle && question.orientation === PhotoOrientation.portrait,
      'camera__overlay-circle_landscape': question.overlay === PhotoOverlay.circle && question.orientation === PhotoOrientation.landscape,
      'camera__overlay-square_portrait': question.overlay === PhotoOverlay.square && question.orientation === PhotoOrientation.portrait,
      'camera__overlay-square_landscape': question.overlay === PhotoOverlay.square && question.orientation === PhotoOrientation.landscape
    }"
    ></div>

    <div class="video-wrapper">
      <video id="video" #video poster="no-poster" autoplay muted playsinline></video>
      <canvas id="canvas" #canvas></canvas>
    </div>

    <div *ngIf="question.type === QuestionTypes.VideoQuestion && !recordingFinished" class="camera__time-wrapper">
      <div class="camera__time">{{timerService.displayTime}} / {{timerService.maxDisplayTime}}</div>
    </div>

    <div *ngIf="recordingFinished" class="camera__recordingFinished">{{'Html5CanvasPage.recordingCompleted' | translate}}</div>

    <div *ngIf="question.allowRecordingInstructions && question.recordingInstructions" class="camera__recordingInstructions">
      {{question.recordingInstructions}}
    </div>

    <ion-row
      class="camera__controls"
      [ngClass]="{
      'camera__controls_portrait': question.orientation === PhotoOrientation.portrait || question.orientation === PhotoOrientation.notFixed,
      'camera__controls_landscape': question.orientation === PhotoOrientation.landscape
    }"
    >
      <ion-col class="camera__column">
        <ion-button
          *ngIf="!showStopRecording"
          (click)="cancel()"
          class="camera__closeButton"
          fill="clear"
          aria-label="Close"
          id="close_button"
        >
          <ion-icon
            slot="icon-only"
            src="assets/images/camera/close.svg"
            class="camera__closeIcon"
            aria-labelledby="close_button"
          ></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col class="camera__column">
        <ion-button
          *ngIf="question.type === QuestionTypes.PhotoQuestion"
          fill="clear"
          (click)="capture()"
          id="take_photo"
          class="camera__captureButton"
          aria-label="Take photo"
        >
          <ion-icon
            slot="icon-only"
            src="assets/images/camera/capture.svg"
            class="camera__captureIcon"
            aria-labelledby="take_photo"
          ></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="!showStopRecording && question.type === QuestionTypes.VideoQuestion"
          fill="clear"
          (click)="startRecording()"
          class="camera__captureButton"
          aria-label="Start recording"
          id="start_recording"
        >
          <ion-icon
            slot="icon-only"
            src="assets/images/camera/start-recording.svg"
            class="camera__captureIcon"
            aria-labelledby="start_recording"
          ></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="showStopRecording && question.type === QuestionTypes.VideoQuestion"
          fill="clear"
          (click)="stopRecording()"
          class="camera__captureButton"
          aria-label="Stop recording"
          id="stop_recording"
        >
          <ion-icon
            slot="icon-only"
            src="assets/images/camera/stop-recording.svg"
            class="camera__captureIcon"
            aria-labelledby="stop_recording"
          ></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col class="camera__column">
        <ion-button
          [disabled]="disableFlip"
          [hidden]="captured || question.camera !== CameraView.AllowChanging || hideFlip"
          (click)="flip()"
          class="camera__flipButton"
          fill="clear"
          aria-label="Flip camera"
          id="flip-camera"
        >
          <ion-icon
            slot="icon-only"
            src="assets/images/camera/flip-camera.svg"
            class="camera__flipIcon"
            aria-labelledby="flip_camera"
          ></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </section>
</ion-content>
